module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "filters"
  }, [(!_vm.current_user.isSeller()) ? _c('dropdown-select', {
    staticClass: "field user-filter",
    attrs: {
      "options": _vm.users_options
    },
    on: {
      "input": function($event) {
        return _vm.loadGroupedDoneTasksData(_vm.card_filters)
      }
    },
    model: {
      value: (_vm.user_filter),
      callback: function($$v) {
        _vm.user_filter = $$v
      },
      expression: "user_filter"
    }
  }) : _vm._e()], 1), _c('div', {
    attrs: {
      "id": "done-tasks-calendar"
    }
  }, [_c('div', {
    attrs: {
      "id": "calendar"
    }
  }), _c('div', {
    attrs: {
      "id": "tasks-list-group"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Tarefas executadas")]), _c('span', {
    attrs: {
      "id": "calendar-input"
    }
  }, [_vm._v(_vm._s(_vm.date_string))]), _c('div', {
    staticClass: "clear"
  }), (_vm.loading) ? _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _c('br'), _c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1) : _c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.done_tasks_grouped), function(task, key) {
    return (_vm.valid_label_task_card(key)) ? _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "icon",
      class: _vm.class_of_tasks[key]
    }), _c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(_vm.countingNumber(task)) + "  ")]), _c('span', [_vm._v(_vm._s(_vm.label_of_tasks[key]))])]) : _vm._e()
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39b0505c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/calendar.vue
// module id = 1079
// module chunks = 1